import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import AlertBellIcon from 'dibs-icons/exports/AlertBell';
import styles from './Notifications-style.scss';

const NotificationsIcon = props => {
    const { onMouseEnter, hasUnread } = props;

    const alertBellIconClasses = classnames(styles.icon, {
        [styles.hasUnread]: hasUnread,
    });

    const dataTn = `notifications-link${hasUnread ? '-unread' : ''}`;

    let iconWrapperProps = {
        className: styles.iconWrapper,
    };

    if (onMouseEnter) {
        iconWrapperProps = { ...iconWrapperProps, onMouseEnter };
    }

    return (
        <div {...iconWrapperProps}>
            <span data-tn={dataTn} className={alertBellIconClasses}>
                <AlertBellIcon />
            </span>
        </div>
    );
};

NotificationsIcon.propTypes = {
    onMouseEnter: PropTypes.func,
    favoritesUrl: PropTypes.string,
    hasUnread: PropTypes.bool,
};

NotificationsIcon.defaultProps = {
    hasUnread: false,
};

export default NotificationsIcon;
